// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { IMapUiState, IRootState, IInteractiveSnackbar } from '../../../../../CommonScripts/Abstractions';
import {interactiveSnackbarState} from './Notifications/interactiveSnackbarState';
import { Module } from 'Vuex';

const theState: IMapUiState = {
    navDrawerVisible: false,
    dialogVisible: false,
    appPanelVisible: false,
    activityMessage: null,
    errorMessage: null,
    navigationItems: null,
    contentControls: null,
    speedDialItems: null,
    notificationMessage: null,
    showNotification: false,
    toolstripItems: null,
    checkedIamHuman: false
 };

export const uiState: Module<IMapUiState, IRootState> = {
    namespaced: true,
    state: theState,
    actions: {
    },
    mutations: {
        setNavDrawerVisible(state, navDrawerVisible) {
            state.navDrawerVisible = navDrawerVisible;
        },
        setDialogVisible(state, dialogVisible) {
            state.dialogVisible = dialogVisible;
        },
        setAppPanelVisible(state, appPanelVisible) {
            state.appPanelVisible = appPanelVisible;
        },
        setActivityMessage(state, activityMessage) {
            state.activityMessage = activityMessage;
        },
        setErrorMessage(state, errorMessage) {
            state.errorMessage = errorMessage;
        },
        setNavigationItems(state, navigationItems) {
            state.navigationItems = navigationItems;
        },
        setContentControls(state, contentControls) {
            state.contentControls = contentControls;
        },
        setSpeedDialItems(state, speedDialItems) {
            state.speedDialItems = speedDialItems;
        },
        setShowNotification(state, showNotification) {
            state.showNotification = showNotification;
        },
        setNotificationMessage(state, notificationMessage) {
            state.notificationMessage = notificationMessage;
        },
        setToolstripItems(state, toolstripItems) {
            state.toolstripItems = toolstripItems;
        },
        setCheckedIamHuman(state, value) {
            state.checkedIamHuman = value;
        }
    },
    modules: {
        interactiveSnackBar: interactiveSnackbarState
    }
};
//# sourceMappingURL=overlays.js.map

